module.exports = __webpack_public_path__ + "static/media/LineImpressum.31396a68.png";